import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=05653fb6&scoped=true&"
import script from "./Tiptap.vue?vue&type=script&lang=js&"
export * from "./Tiptap.vue?vue&type=script&lang=js&"
import style0 from "./Tiptap.vue?vue&type=style&index=0&id=05653fb6&scoped=true&lang=css&"
import style1 from "./Tiptap.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Tiptap.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05653fb6",
  null
  
)

export default component.exports